module.exports = __webpack_public_path__ + "src/images/products/trendsetter/110_Appliqued and Printed Denim Jacket.png";